import { isImageXData, isVectorImageData, isWPhotoData, isBackgroundMedia, isBuilderImageData, isBuilderImageContainer } from '../../data-extractor/components-type-guards';
import { assertNotOptional } from '@wix/seo-common-core';
export function updateImageProperties(component, _ref) {
  let {
    alt,
    decorative,
    builderLabel
  } = _ref;
  const {
    data,
    design,
    type
  } = component;
  const updatedData = data ? {
    ...data
  } : undefined;
  let updatedDesign = design ? {
    ...design
  } : undefined;
  if (isImageXData(updatedData)) {
    updatedData.image.alt = alt;
    updatedData.image.decorative = decorative;
  } else if (isWPhotoData(updatedData) || isVectorImageData(updatedData)) {
    updatedData.alt = alt;
    updatedData.decorative = decorative;
  } else if (isBackgroundMedia(updatedDesign)) {
    updatedDesign = handleBackgroundMedia(updatedDesign, alt, decorative);
  } else if (builderLabel && isBuilderImageContainer(updatedData)) {
    const imageData = updatedData[builderLabel];
    if (isBuilderImageData(imageData)) {
      imageData.alt = alt;
      decorative !== undefined && (updatedData.decorative = decorative);
    }
  } else {
    throw new Error(`Unknown image component type: ${type}`);
  }
  const updatedComponent = {
    ...component
  };
  if (updatedData) {
    updatedComponent.data = updatedData;
  }
  if (updatedDesign) {
    updatedComponent.design = updatedDesign;
  }
  return updatedComponent;
}
function handleBackgroundMedia(design, alt, decorative) {
  assertNotOptional(design.background, 'background');
  const background = design.background;
  if ('mediaRef' in background) {
    if (background.mediaRef.type === 'Image') {
      background.mediaRef.alt = alt;
      background.mediaRef.decorative = decorative;
      return design;
    }
  }
  throw new Error('Cannot update background media properties - unknown design structure');
}
//# sourceMappingURL=update-image-properties.js.map